import React, { useState, useRef, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Badge,
  Box,
} from "@mui/material";
import NotificationsIcon from "../../assets/icons/notification-icon.png";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { SecondaryAppBarProps } from "../../interfaces/layout.interface";
import CustomIcon from "../../assets/icons/fi-rr-align-left (1).svg";
import { useNavigate } from "react-router-dom";
import NotificationDrawer from "../../views/notification/Notification";
import "./SecondaryAppBar.scss";
import { IdleTimerProvider } from "react-idle-timer";
import { getConfig } from "../../auth/AuthSettings";
import { Dialog,} from "@mui/material";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ContactUSIcon from "../../assets/icons/contact-us.png";
import { useNotificationService } from "../../services/notifications/service";


const SIDEBAR_WIDTH_OPEN = 200;
const SIDEBAR_WIDTH_CLOSED = 60;

const SecondaryAppBar: React.FC<SecondaryAppBarProps> = ({
  drawerOpen,
  handleDrawerToggle,
}) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const storedData = localStorage.getItem("customerInfo");
  const customerInfo = storedData ? JSON.parse(storedData) : {};
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
    const auth0Config = getConfig();
  const ms = 1000;
  const idleTimerRef = useRef(null);
  const [autoLogoutTimerId, setAutoLogoutTimerId] = useState<any>(null);
  const [openInactivityDialog, setOpenInactivity] = useState(false);
  const { notificationList, fetchAllNotifications } = useNotificationService();
  const [showComponent, setShowComponent] = useState(false);
  const [notificationUnreadCount, setNotificationUnreadCount] = useState(0);
  const NotificationGetPayloadData = {
    email: customerInfo?.sourceEmail,
    accountNumber: customerInfo?.customerAccountNumber,
  };

  useEffect(() => {
    setInterval(() => {
      fetchAllNotifications(NotificationGetPayloadData);
    }, 30000);
  }, [fetchAllNotifications]);

  useEffect(() => {
    setNotificationUnreadCount(notificationList.filter((user) => user.userEmail == null).length);
  });

  const handleViewProfile = () => {
    navigate("/profile");
    handleMenuClose();
  };

  const handleContactus = () => {
    navigate("/contact-us");
  }

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("customerInfo");
    const redirectUrl = `${process.env.REACT_APP_LKQPORTAL_URL}logout` || "/";
    window.location.replace(redirectUrl);
    handleMenuClose();
  };

  const handleNotificationDisplay = () => {
    setShowComponent((prev) => !prev);
  };

  const onCloseNotification = () => {
    setShowComponent(false);
  };

  const onNotificationUnreadStatusCount = (data: any) => {
    setNotificationUnreadCount(data);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const sidebarWidth = drawerOpen ? SIDEBAR_WIDTH_OPEN : SIDEBAR_WIDTH_CLOSED;

  
  function callAutoLogout() {
    if (!openInactivityDialog) {
      setAutoLogoutTimerId(
        setTimeout(handleLogout, auth0Config.autloLogout * ms)
      );
    } else {
      window.clearTimeout(autoLogoutTimerId);
      setAutoLogoutTimerId(null);
    }
    setOpenInactivity(!openInactivityDialog);
  }

  return (
    <React.Fragment>
      <IdleTimerProvider
        ref={idleTimerRef as any}
        timeout={auth0Config.idleTimeout * ms}
        onIdle={callAutoLogout}
      >
        <Dialog
          open={openInactivityDialog}
          onClose={() => {
            setOpenInactivity(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {auth0Config.popUpTitle}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {auth0Config.popUpContent1}
              {auth0Config.autloLogout}
              {auth0Config.popUpContent2}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type="button" onClick={callAutoLogout} variant="outlined">
              Continue
            </Button>
            <Button type="button" onClick={handleLogout} variant="contained">
              Logout
            </Button>
          </DialogActions>
        </Dialog>

        <AppBar
          position="fixed"
          className="secondary-app-bar"
          sx={{
            backgroundColor: "#FFFFFF",
            color: "#000",
            top: 40,
            left: `${sidebarWidth}px`,
            width: `calc(100% - ${sidebarWidth}px)`,

            transition: "left 0.3s, width 0.3s",
          }}
        >
          <Toolbar
            className="toolbar"
            sx={{ minHeight: 56, height: 56, alignItems: "center" }}
          >
            {" "}
            {/* Left Section: Hamburger Menu and App Name */}
            <Box className="left-section">
              <IconButton
                color="inherit"
                edge="start"
                onClick={handleDrawerToggle}
                className="menu-icon"
              >
                <img src={CustomIcon} alt="Custom Icon" className="custom-icon" />
              </IconButton>
              <Typography className="app-name" variant="h6" color="inherit">
                Auto Data Labels
              </Typography>
            </Box>
            {/* Right Section: Notifications and Profile */}
            <Box className="right-section">
              <Box onClick={handleContactus} 
                className="contactus-view">
                <IconButton
                color="inherit"
                edge="start"
              >
                <img src={ContactUSIcon} alt="Contact Us" className="contactus-icon" />
              </IconButton>
              </Box>
              <Box className="notification-view" onClick={handleNotificationDisplay}>
                <IconButton color="inherit">
                  <Badge badgeContent={notificationUnreadCount} color="error">
                    <img src={NotificationsIcon} alt="Notification" className="notification-icon" />
                  </Badge>
                </IconButton>

                <NotificationDrawer
                  open={showComponent}
                  onClose={onCloseNotification}
                  sentData={onNotificationUnreadStatusCount}
                />
              </Box>
              <Box className="profile-section" onClick={handleMenuOpen}>
                <Box>
                  {customerInfo.firstName && (
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", color: "#333", textAlign: "end" }}
                    >
                      {`${customerInfo.firstName} ${customerInfo.lastName}`}
                    </Typography>
                  )}
                  <Typography className="customerName">
                    {`${customerInfo.customerAccountNumber} - ${customerInfo.customerAccountName}`}
                  </Typography>
                </Box>
                <ArrowDropDownIcon color="inherit" />
              </Box>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <MenuItem onClick={handleViewProfile}>View Profile</MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </AppBar>
      </IdleTimerProvider>
    </React.Fragment>

  );
};

export default SecondaryAppBar;
